<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!-- Main -->
        <main class="finishAdoptionScreen">
            <div class="container-fluid">
                <div class="finishAdoption__wrapper">

                    <!-- Text -->
                    <div class="finishAdoption__msg">
                        <h2 class="text-center">
                            Tvoja kravička <span id="cow-name" class="--colorOrange">Mutant</span> je rezervovaná a čaká kým doplníš ešte <span id="ean-count-left" class="--colorOrange">1 EAN kód</span>
                        </h2>

                        <div class="finishAdoption__countdown text-center mb-3">ZOSTÁVA 10 DNÍ</div>
                        <p class="text-center mb-3">Ak chceš mať kravičku adoptovanú je potrebné, aby si do 10 dní zadal aj ostatné kódy zo slovenských mliečnych výrobkov. Všetky výrobky nájdeš v <a target="_blank" href="https://www.adoptujkravicku.sk/vyrobky-zapojene-do-projektu">zozname výrobkov</a>.</p>

                        <div class="finishAdoption__btns text-center">
                            <a href="" class="btn --secondary mr-md-2 mb-2 mb-md-0">Zoznam mojich kravičiek</a>
                            <a href="" class="btn --primary">Doplniť ean kódy</a>
                        </div>
                    </div>
                    <!-- .Text -->

                </div>
            </div>
        </main>
        <!-- .Main -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    export default {
        components: {
            HeaderProfil
        },
        props: [
            'profil'
        ],
        mounted() {
            this.getKravickaId()
            this.getKravickaInfo()
        },
        data() {
            return {
                kravicka_id: '',

                kravicka_meno: '',
                kravicka_meno_rodica: '',
                kravicka_cislo: '',
                kravicka_dvor: '',
                kravicka_datum: '',

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },

            // mounted
            getKravickaId() {

                if ( this.$route.params.kravicka_id ) {
                    this.kravicka_id = this.$route.params.kravicka_id
                    sessionStorage.setItem("kravickaId", this.$route.params.kravicka_id)
                }
                else {
                    this.kravicka_id = sessionStorage.getItem("kravickaId")
                }

                if ( !this.kravicka_id ) {
                    this.$router.push({ name: 'login' })
                }

            },

            // mounted
            getKravickaInfo() {
                EventService.getKravickaInfo(this.$route.params.kravicka_id)
                    .then(response => {
                        //console.log(response.data)
                        // fix ak príde response s chybovou hláškou (Undefined index: ean_kravicky)
                        /*if (typeof(response.data) == 'string') {
                            var toj = response.data.split("<br />")
                            var obj = JSON.parse(toj[0])
                            console.log(obj.data[0])
                            response.data = obj
                        }*/
                        this.kravicka_cislo = response.data.data[0].kravicka_regcislo
                        this.kravicka_dvor  = response.data.data[0].dvor_id.dvor_nazov
                        this.kravicka_datum = response.data.data[0].kravicka_datum_nar
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },
        }
    }
</script>